export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['center'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignCenter'],
                component1: {
                  type: 'header-full',
                  data: {
                    blockModifiers: ['noPadding', 'mediumWeight', 'smallerFontSize'],
                    text: 'Expand your sales reach and be shoppable in any digital content.',
                    textMobile: 'Expand your sales reach and be shoppable in any digital content.',
                    links: [
                      {
                        linkText: 'Create your free account and get started with Spotin',
                        // linkSubText: '',
                        callback: 'openGetStartedMenu',
                        icon: 'arrow_right_12px',
                      },
                    ]
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "Seller_page_header_animation_white.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             headerSize: 'large',
    //             header1: 'Spotin for<br>brands &<br>sellers',
    //             text2: "<p>More than ever, convenience is the key to success in commerce. Being in the right place, in the right moment, offering consumer experiences with the least amount of friction.</p><p>Spotin exchanges data directly with your e-commerce system to make your full product catalog available to buy from within any type of online content, on any type of platform.</p><p>Your customer, your prices, your sales - where and wherever you want to be seen and your products be sold.</p>",
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     blockModifiers: ['center'],
    //     sections: [
    //       {
    //         full: {
    //           component: 'animation',
    //           data: {
    //             blockModifiers: ['endMargin'],
    //             src: "EcomContent.json",
    //           }
    //         }
    //       }
    //     ]
    //   },
    // },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: 'Remove friction. Add convenience.',
                text2: "<p>More than ever, convenience is the key to success in commerce. Being in the right place, in the right moment, offering consumer experiences with the least amount of friction.</p><p>Spotin exchanges data directly with your e-commerce system to make your full product catalog available to buy from within any type of online content, on any type of platform.</p><p>Your customer, your prices, your sales - where and wherever you want to be seen and your products be sold.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom','minTopPadding'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: 'A commercial layer with your products on top of any online content.',
                text2: "Spotin offers a high converting commercial layer to any type of editorial content for quick and easy checkout. A seamless user experience in the best possible context.",
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                showSlider: true,
                blockModifiers: ['sideMargins'],
                src: 'desktop_spot.mp4',
                srcMobile: 'mobile_spot.mp4',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                header1: 'Expand your<br>sales reach.',
                text1: "With Spotin you increase the exposure and availability of your products (or services) in the right place for your brand, and where your customers are. And being available in new channels and directly from within any content also lets you reach and obtain a new customer base.",
                header2: 'Be available when<br>the interest is peaking.',
                text2: "Working with Spotin and Content Commerce means making your products available at the moment of discovery, and when the interest is peaking, turning the point of inspiration to the point of sale.",
                header3: 'No redirects &<br>less abandoned carts.',
                text3: "Some of the biggest reasons for abandoned carts are customer redirection and page reloads. Often customers themselves have to search where to buy a product. Spotin reduces friction and increases conversion by enabling purchases within any content.",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','sideMargins','alignColumnCenter'],
                headerSize: 'large',
                // columns: 3,
                header2: '”Being shoppable from within credible content at the very moment our customers\' interest is at its highest, and building relationships with new consumers in collaboration with Spotin and their content commerce solution is really exciting, we look forward to it.”',
                text2: '<strong>Sophie Gyllenhammar Mattsson</strong><br>Founder and designer, Sophie By Sophie.',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // columns: 3,
                blockModifiers: ['centerAlignText'],
                // headerSize: 'large',
                header2: 'How to increase sales',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['centerAlignText', 'endMargin'],
                mobile: {
                  singleColumn: true,
                  startColumn: 1,
                  animate: true,
                },
                img1: {
                  src: 'circle_1.svg',
                  alt: 'Step 1',
                },
                text1: 'Contact us to get started',
                img2: {
                  src: 'circle_2.svg',
                  alt: 'Step 2',
                },
                text2: 'Integrating Spotin with your e-com',
                img3: {
                  src: 'circle_3.svg',
                  alt: 'Step 3',
                },
                text3: 'Select content creators to work with',
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                header1: 'The Swiss-army-knife of e-commerce',
                text2: "Spotin comes with many features acting as commercial highways to checkout. From adding shoppability to highlighted products to cross-sell, by seamless access to your complete product catalog.",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Spots",
                text2: "Spots make all your products buyable from within any image within any online content where you want your brand to be seen.</p><p>Spots are direct access sales channels to your e-commerce system. This means that just by clicking on a Spot customers are provided product information directly from you, and can shop right on the spot.</p><p>A single image can contain several spots for you to make additional sales. Your product images are also tagged with spots to enable related sales. This means that customers can discover and buy from within your full product catalog from a single editorial spot.</p>",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','maxWidth500'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'Stina_goya_scarf_hat.jpg',
                  alt: 'Spots demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Buy buttons",
                text2: "Buy buttons makes any content into an image-based sales channel and are suitable for pictures displaying one particular item and enables purchases with one quick and effortless checkout.",
                link2: {
                  linkText: 'Know more',
                  route: 'incontent',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','maxWidth500'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'little_liffner_TALL_TULIP TOTE_DUSTY_PINK.png',
                  alt: 'Buy button demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "The shop",
                text2: "<p>Your full catalog is included in the shops generated by Spotin on any publisher site you want to be seen on. Always everything, always the latest, with up to date stock and prices within the publisher's content.</p><p>Within the Shop publishers can highlight your products in various ways using predefined templates. And customers can browse and purchase from your entire product catalog.</p>",
                // The Shop features your own brand page, showcasing your brand the way you want it.
                link2: {
                  linkText: 'Know more',
                  route: 'shop',
                },
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                showSlider: true,
                blockModifiers: ['sideMargins', 'endMargin'],
                src: 'desktop_shop.mp4',
                srcMobile: 'mobile_shop.mp4',
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        // blockModifiers: [],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header1: 'Manage all your commerce needs in Spotin Portal',
                text2: "<p>Designed exclusively for sellers and content makers, <a style='text-decoration: underline;' href='/portal'>Spotin Portal</a> is your gateway to finding new partnerships, agreeing on commissions, managing existing collaborations, setting up campaigns, analysing the performance and supercharging your content commerce.</p>",
                link2: {
                  linkText: 'Know more',
                  route: 'portal',
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['alignColumnCenter'],
                component2: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    blockModifiers: ['endMargin','noMobileBottomMargin'],
                    src: "portal_dashboard.json",
                  }
                }
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['noPadding'],
        sections: [
          {
            full: {
              component: 'circles',
              data: {
                circles: [
                  {
                    fullHeader: true,
                    header: "The<br>Spotin<br>way",
                  },
                  {
                    header: "No sale. No cost.",
                    text: "Spotin and colaborating publishers only take a commission on orders that are neither cancelled nor returned.",
                  },
                  {
                    header: "Control your<br>digital exposure.",
                    text: "You decide where and how your brand and your products are exposed.",
                  },
                  {
                    header: "Always updated.",
                    text: "Live-update of stock availability and prices on SKU-level with your system. Configurable exchange of products (e.g. variants and images), and exchange of orders.",
                  },
                  {
                    header: "Your sales.",
                    text: "Orders from Spotin are added to your system (labelled with Spotin) and you fulfill orders from Spotin exactly as those from your own store.",
                  },
                  {
                    header: "Integrates with<br>any platform.",
                    text: "Spotin has ready-made integration solutions for the most common e-commerce platforms, and the Spotin API allows you to connect any platform with Spotin.",
                  },
                  {
                    header: "Customer<br>relationship<br>is yours.",
                    text: "With Spotin you are the legal seller. You are the part obtaining the information from and relationship with your new consumer.",
                  },
                  {
                    header: "GDPR-<br>compliant by<br>nature.",
                    text: "Spotin is 100% compliant with GDPR. Neither our tech, implementation nor our business model rely on tracking of users or storing private data.",
                  },
                  {
                    header: "The best user<br>experience",
                    text: "Spotin is designed with the end user in mind. Removing as many barriers as possible to create the most convenient shopping experience.",
                  },
                ]
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Commerce on the<br>terms of brands,<br>content makers &<br>people.',
                text2: "<p>Through this new type of commerce provided by Spotin brands can distribute their sales and create new sales channels. Brands can give their products increased exposure and availability in the ideal context. Spotin also presents a way of meeting customers when the buying interest is at its highest. For the brands this means higher conversion rates and with a holistic view from discovery to purchase the impact of campaigns are measurable in actual sales.</p><p>At the same time, content creators can keep visitors on their content instead of sending them somewhere else with links. With Spotin content makers get a commission on the sales they generate with their content through revenue sharing so that they can keep creating engaging content. At the same time they can offer visitors additional value by providing product information, the convenience to buy directly within their content, and to discover products related to the content.</p><p>With content commerce people get to discover brands and products within the content, instead of searching. They get all the info they need to buy on the spot, directly from brands. Customers can add products from different brands to their shopping bag and complete the order in one single checkout. In short, a much more convenient experience.</p>",
              }
            },
            bottom: {
              component: 'image-block',
              data: {
                blockModifiers: ['sideMargins'],
                src: "venn_content_commerce.svg",
                srcMobile: "venn_content_commerce_mobile.svg",
                alt: "Brands / Content makers / People venn diagram",
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'The Spotin service',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'service',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin Portal',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'portal',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'What is<br>content commerce?',
                    blockModifiers: ['offWhiteOnBlue', 'alignLabelLeft', 'alignLabelTop'],
                    path: 'contentcommerce',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Sellers.js